<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/logo.png" width=155/>
          </span>
          <span class="logo-lg">
            <img src="assets/logo.png" width=155/>
          </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/logo.png" width=155/>
          </span>
          <span class="logo-lg">
            <img src="assets/logo.png" width=155/>
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

   
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
          <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="16"> <span
            class="ms-1">{{countryName}}</span>
          <img *ngIf="flagvalue === undefined" src="{{valueset}}" alt="Header Language" height="16">
          <span *ngIf="flagvalue === undefined" class="ms-1">English</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item notify-item" *ngFor="let item of listLang"
            (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
            <img src="{{item.flag}}" alt="user-image" class="me-1" height="12"> <span
              class="align-middle">{{item.text}}</span>
          </a>
          <!-- item-->
        </div>
      </div>
    
    
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <!-- <img class="rounded-circle header-profile-user" src="assets/images/users/avatar-1.jpg" alt="Header Avatar"> -->
          <span class="d-none d-xl-inline-block ml-1">{{currentUser.name}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          
          <!-- <a class="dropdown-item" href="javascript: void(0);"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-wallet font-size-16 align-middle me-1"></i>{{ 'HEADER.LOGIN.MY_WALLET' | translate}}</a>
          --> 
          <a class="dropdown-item d-block" href="javascript: void(0);"  (click)="editModal(largeDataModal)"><i
              class="bx bx-wrench font-size-16 align-middle me-1"></i>{{ 'MODULAR.LOGIN.CHANGE_PASSWORD' | translate}}</a>
          <!--<a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-lock-open font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.LOCK_SCREEN' | translate}}</a> -->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'MODULAR.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>

      <!-- <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleRightSidebar()">
          <i class="bx bx-cog bx-spin"></i>
        </button>
      </div> -->

    </div>
  </div>
</header>
<ng-template #largeDataModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">{{'MODULAR.CHANGE_PASSWORD.MODEL_TITLE' |translate}}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
  </div>
  <div class="modal-body">

    
      <form (ngSubmit)="typeSubmit()" [formGroup]="typeValidationForm">
        
        <div class="form-group mb-2">
          <label>{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD.CURRENT_PASSWORD' |translate}}</label>
          <input type="text" class="form-control" formControlName="current_password"
            [ngClass]="{'is-invalid': typesubmit && type.current_password.errors}"  />
          <div *ngIf="typesubmit && type.current_password.errors" class="invalid-feedback">
            <span *ngIf="type.current_password.errors.required">{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD_VALIDATION_MSG.CURRENT_PASSWORD' |translate}}</span>
          </div>
        </div>
        
        <div class="form-group mb-2">
          <label>{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD.NEW_PASSWORD' |translate}}</label>
          <div>
            <input type="password" class="form-control"autocomplete="new-password" maxlength="50" formControlName="new_password"
              [ngClass]="{'is-invalid': typesubmit && type.new_password.errors}" />
            <div *ngIf="typesubmit && type.new_password.errors" class="invalid-feedback">
              <span *ngIf="type.new_password.errors.required">{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD_VALIDATION_MSG.NEW_PASSWORD.REQUIRED' |translate}}</span>
              <span *ngIf="type.new_password.errors.minlength">{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD_VALIDATION_MSG.NEW_PASSWORD.PATTERN' |translate}}</span>
                <span *ngIf="type.new_password.errors.pattern"> {{'MODULAR.CHANGE_PASSWORD.FORM_FIELD_VALIDATION_MSG.NEW_PASSWORD.MIN' |translate}}</span>

            </div>
          </div>
          <div class="mt-2">
            <input type="password" class="form-control" placeholder="{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD.RE_TYPE_PASSWORD' |translate}}" formControlName="confirm_password"
              [ngClass]="{'is-invalid': typesubmit && type.confirm_password.errors}" />
            <div *ngIf="typesubmit && type.confirm_password.errors" class="invalid-feedback">
              <span *ngIf="type.confirm_password.errors.required">{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD_VALIDATION_MSG.RE_TYPE_PASSWORD.REQUIRED' |translate}}</span>
              <span *ngIf="type.confirm_password.errors.mustMatch">{{'MODULAR.CHANGE_PASSWORD.FORM_FIELD_VALIDATION_MSG.RE_TYPE_PASSWORD.VALUE_SAME' |translate}}</span>
            </div>
          </div>
        </div>
      
        <div class="form-group mb-2 mt-3">
          <div>
            <button type="reset" class="btn btn-secondary float-end">
              {{'MODULAR.COMMON.RESET' |translate}}
            </button>
            <button type="submit" class="btn btn-primary  float-end me-1">
              {{'MODULAR.COMMON.SUBMIT' |translate}}
            </button>
          </div>
        </div>
      </form>
    
  </div>
</ng-template>

